import React from "react";
import { MultiselectReturnType } from "@coworker/app/src/types/multiselectReturnType";

export const SelectedTasksContext = React.createContext<{
  inProgress: MultiselectReturnType;
  open: MultiselectReturnType;
} | null>(null);
